import { ScreensList } from '@shared-core/navigation'
import { Layout } from '@web/components/layout'
import { PhoneFrame } from '@web/components/phone-frame'
import { PhoneFrameLayout } from '@web/components/phone-frame/layout'
import { APP_ROUTE_KEYS, isPhoneScreen, isPublicScreen } from '@web/router/app-routes'
import { RouteErrorBoundary } from '@web/router/error-boundary'
import { PrivateGuard, PublicGuard } from '@web/router/guards'
import { componentFor, homePath, type TabRouteKey, toPath } from '@web/router/routes-screens'
import { RouteTransitionView } from '@web/router/transition/view'
import { createBrowserRouter, Navigate, Outlet } from 'react-router-dom'

// Каждый leaf-экран — в RouteTransitionView: переход между роутами монтирует новый
// элемент, и обёртка проигрывает мягкий scale-вход (iOS-стиль). Layout/гарды не
// анимируются — навигация остаётся стабильной, анимируется только контент.

function renderScreen(key: TabRouteKey) {
  const Component = componentFor(key)

  return (
    <RouteTransitionView animate={key !== ScreensList.CARD_DETAILS && key !== ScreensList.HOME_START}>
      <Component />
    </RouteTransitionView>
  )
}

export const router = createBrowserRouter([
  {
    element: <PhoneFrameLayout />,
    errorElement: (
      <PhoneFrame>
        <RouteErrorBoundary />
      </PhoneFrame>
    ),
    children: [
      {
        path: '/',
        element: <Navigate to={homePath} replace />,
      },
      ...APP_ROUTE_KEYS.filter(isPhoneScreen).map((key) => ({
        path: toPath(key),
        element: renderScreen(key),
      })),
      {
        element: <PublicGuard />,
        children: APP_ROUTE_KEYS.filter((key) => isPublicScreen(key) && !isPhoneScreen(key)).map((key) => ({
          path: toPath(key),
          element: renderScreen(key),
        })),
      },
      {
        element: <PrivateGuard />,
        children: [
          {
            element: (
              <Layout>
                <Outlet />
              </Layout>
            ),
            children: APP_ROUTE_KEYS.filter((key) => !isPublicScreen(key)).map((key) => ({
              path: toPath(key),
              element: renderScreen(key),
            })),
          },
        ],
      },
    ],
  },
])
